import * as bootstrap from 'bootstrap';

// Chart.js — exposed globally for inline scripts in modules
import Chart from 'chart.js/auto';
import Annotation from 'chartjs-plugin-annotation';
Chart.register(Annotation);
window.Chart = Chart;

// Photoswipe
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

const lightbox = new PhotoSwipeLightbox({
    gallery: '.photoswipe',
    children: 'a',
    showHideAnimationType: 'none',
    zoomAnimationDuration: false,
    bgOpacity: 1,
    loop: false,
    pswpModule: PhotoSwipe,
});
lightbox.init();

document.addEventListener('DOMContentLoaded', function () {

    // Close one-pager navigation on nav link click
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarCollapse) {
        navbarCollapse.addEventListener('click', function (e) {
            const link = e.target.closest('a');
            if (link && !link.dataset.bsToggle) {
                const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
                if (bsCollapse) bsCollapse.hide();
            }
        });
    }

    // Carousel touch swipe
    document.querySelectorAll('.carousel').forEach(function (el) {
        let touchStartX = 0;
        el.addEventListener('touchstart', function (e) {
            touchStartX = e.touches[0].clientX;
        }, { passive: true });
        el.addEventListener('touchend', function (e) {
            const dx = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(dx) > 50) {
                const carousel = bootstrap.Carousel.getOrCreateInstance(el);
                dx < 0 ? carousel.next() : carousel.prev();
            }
        }, { passive: true });
    });

});
